import {BaseParamType} from '../../../../../@polygonjs/polygonjs/src/engine/params/_Base';
import {CoreType} from '../../../../../@polygonjs/polygonjs/src/core/Type';
import {CodeExporterDispatcher} from './Dispatcher';
import {BaseNodeType} from '../../../../../@polygonjs/polygonjs/src/engine/nodes/_Base';
import {ParamType} from '../../../../../@polygonjs/polygonjs/src/engine/poly/ParamType';
import {PARAM_OPTION_NAMES} from '../../../../../@polygonjs/polygonjs/src/engine/params/utils/OptionsController';

export class ParamCodeExporter<T extends BaseParamType> {
	_lines: string[] = [];
	constructor(protected _param: T) {}

	process(): string[] {
		this._lines = [];

		let default_value = this.default_value();
		if (CoreType.isString(default_value)) {
			default_value = `'${default_value}'`;
		}
		if (CoreType.isArray(default_value)) {
			default_value = `[${default_value}]`;
		}
		if (CoreType.isObject(default_value)) {
			default_value = `${JSON.stringify(default_value)}`;
		}

		if (this._param.options.isSpare() && !this._param.parentParam()) {
			const create_line = `${this.node_var_name()}.addParam('${this._param.type()}', '${this._param.name()}', ${default_value}, ${JSON.stringify(
				this._param.options.current()
			)})`;
			this._lines.push(create_line);
		}

		if (!this._param.isDefault()) {
			this.add_main();
		}
		this.add_options();

		return this._lines;
	}

	setValueLinesWithFullPath(): string {
		const node: BaseNodeType = this._param.node;

		let current_value = this._param.rawInput();
		if (CoreType.isString(current_value)) {
			current_value = `'${current_value}'`;
		}
		if (CoreType.isArray(current_value)) {
			current_value = `[${current_value}]`;
		}

		let actionCall: string = `set(${current_value})`;

		// TODO: have this in a specialized class
		if (this._param.type() == ParamType.BUTTON) {
			actionCall = 'pressButton()';
		}

		return `scene.node('${node.path()}').p.${this._param.name()}.${actionCall}`;
	}

	// as_code_default_value_string() {
	// 	return `${this.default_value()}`;
	// }
	// as_code_create() {
	// 	return `${this.node().code_var_name()}.add_spare_param( '${this.type()}', '${this.name()}', ${this.as_code_default_value_string()}, ${JSON.stringify(this.options())})`;
	// }

	default_value() {
		return this._param.defaultValue();
	}

	node_var_name() {
		return CodeExporterDispatcher.dispatch_node(this._param.node, {}).var_name();
	}
	prefix() {
		return `${this.node_var_name()}.params.get('${this._param.name()}')`;
	}

	protected add_main() {
		throw `as_code_main abstract call (param type: ${this._param.type()}, path: ${this._param.path()})`;
	}

	add_options() {
		if (this._param.options.hasOptionsOverridden()) {
			const options_overridden = this._param.options.overriddenOptions();
			const keys = this._param.options.overriddenOptionNames();
			for (let option_name of keys) {
				// callback is not set, since it is not serializable
				if (option_name != PARAM_OPTION_NAMES.CALLBACK_OPTION) {
					const option_value = options_overridden[option_name];
					const line =
						this.prefix() + `.options.setOption('${option_name}', ${JSON.stringify(option_value)})`;
					this._lines.push(line);
				}
			}
		}
	}

	//
	//
	// HTML/JS SNIPPETS
	//
	//
	paramHTMLSnippet() {
		return CodeExporterDispatcher.dispatch_param(this._param).HTMLSnippet();
	}
	HTMLSnippet(): string | undefined {
		return undefined;
	}
	paramJSSnippet() {
		return CodeExporterDispatcher.dispatch_param(this._param).JSSnippet();
	}
	JSSnippet(): string | undefined {
		return undefined;
	}
	protected _HTMLId(param: BaseParamType) {
		const elements = param.path().split('/');
		elements.shift();
		return elements.join('-');
	}
}
